import {
  Avatar,
  Col,
  Popconfirm,
  Row,
  Tabs,
  Modal as AntModal,
  Upload,
  Button as AntButton,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
// import * as Icon from "react-icons/all";
import { FaSearch } from "react-icons/fa";
import { CiCircleRemove } from "react-icons/ci";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaFileVideo } from "react-icons/fa";
import { MdDelete, MdEmail } from "react-icons/md";
import { UploadOutlined } from "@ant-design/icons";

import { Colors, Fonts, Images } from "../../config";
import {
  Button,
  Modal,
  Pagination,
  Switch,
  Table,
  Text,
  TextField,
} from "../../components";

import {
  MontserratBold,
  MontserratLight,
  MontserratRegular,
} from "../../config/fonts";
import { AdsAction, UserAction } from "../../store/actions";
import Basic from "../../components/Modal/Basic";
import EditAds from "./EditAds";
import CreateAd from "./CreateAd";

const videoExt = [".mp4", ".mov"];

function AdsManagement() {
  const dispatch = useDispatch();
  const ads = useSelector((state) => state.ads);
  const [page, setPage] = useState(1);
  const [activeTab, setActiveTab] = useState("1");
  const [state, setState] = useState({
    limit: 10,
    offset: 0,
    keyword: "",
    status: "",
    type: "short",
  });
  const [isOpen, setIsOpen] = useState(false);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [mediaPlayerOpen, setMediaPlayerOpen] = useState(false);
  const [mediaType, setMediaType] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");

  // Email modal states
  const [emailModalVisible, setEmailModalVisible] = useState(false);
  const [bulkEmailModalVisible, setBulkEmailModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [emailForm, setEmailForm] = useState({
    message: "",
    attachments: [],
  });

  const handlePagination = (pageNumber) => {
    let offset = (pageNumber - 1) * state.limit;
    setState({ ...state, offset: offset });
    setPage(pageNumber);
  };

  const handleOpen = (data) => {
    setSelectedData(data);
    setIsOpen(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleCreateOpen = () => {
    setIsCreateOpen(true);
  };

  const handleCreateCancel = () => {
    setIsCreateOpen(false);
  };

  const handleDeleteAds = (id) => {
    dispatch(
      AdsAction.deleteAds(id, () => {
        dispatch(AdsAction.getAdsListing(state));
      })
    );
  };

  // Email handlers
  const handleOpenEmailModal = (user) => {
    setSelectedUser(user);
    setEmailModalVisible(true);
  };

  const handleCloseEmailModal = () => {
    setEmailModalVisible(false);
    setSelectedUser(null);
    setEmailForm({ message: "", attachments: [] });
  };

  const handleOpenBulkEmailModal = () => {
    setBulkEmailModalVisible(true);
  };

  const handleCloseBulkEmailModal = () => {
    setBulkEmailModalVisible(false);
    setEmailForm({ message: "", attachments: [] });
  };

  const handleSendEmail = () => {
    if (!emailForm.message) {
      return;
    }

    console.log(emailForm, "emailformsdhskdhsjkdgasgdjhah");

    const payload = {
      user_id: selectedUser?.author?.id,
      message: emailForm.message,
      attachments: emailForm.attachments,
    };
    dispatch(
      UserAction.sendUserEmail(payload, () => {
        handleCloseEmailModal();
      })
    );
  };

  const handleSendBulkEmail = () => {
    if (!emailForm.message) {
      return;
    }
    const payload = {
      type: state.type,
      message: emailForm.message,
      attachments: emailForm.attachments,
    };
    dispatch(
      UserAction.sendBulkEmail(payload, () => {
        handleCloseBulkEmailModal();
      })
    );
  };

  const handleFileChange = (info) => {
    const validFiles = info.fileList
      .filter((f) => f.originFileObj)
      .map((f) => f.originFileObj);
    setEmailForm({ ...emailForm, attachments: validFiles });
  };

  console.log(emailForm, "emailForm");

  useEffect(() => {
    dispatch(AdsAction.getAdsListing(state));
  }, [page, state]);

  const mediaPlayerHandler = (mediaType, url) => {
    setMediaPlayerOpen(true);
    // mediaType true means video else image.
    setMediaType(mediaType ? "video" : "image");
    setMediaUrl(`${process.env.REACT_APP_MEDIA_BASE_URL}${url}`);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setPage(1);
    setState({
      ...state,
      offset: 0,
      type: key === "1" ? "short" : "long",
    });
  };

  return (
    <>
      <div className="wrapper">
        <Row className="flex-row-space-center mb-5 mx-5">
          <Col className="flex-column" span={9}>
            <div className="flex-row-align-center">
              <Text.Basic
                text="Ad Management"
                color={Colors.Black}
                fontSize={25}
                fontWeight={600}
                fontFamily={Fonts[MontserratBold]}
                textAlign="left"
              />
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  background: "#7836FF",
                  borderRadius: "50px",
                  marginInline: "10px",
                }}
              ></span>
              <Text.Basic
                text={ads?.count}
                color={Colors.Black}
                fontSize={18}
                fontWeight={400}
                fontFamily={Fonts[MontserratRegular]}
                textAlign="left"
              />
            </div>
            {/* <Text.Basic
            text={`Deleted artists: ${users?.deleted}`}
            color={Colors.LightGray}
            fontSize={16}
            fontWeight={300}
            fontFamily={Fonts[MontserratLight]}
            textAlign="left"
          />
          <Text.Basic
            text={`These are the users currently registered in the app`}
            color={Colors.LightGray}
            fontSize={14}
            fontWeight={300}
            fontFamily={Fonts[MontserratLight]}
            textAlign="left"
            className="mt-10"
          /> */}
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Row gutter={[25, 25]} className="flex-row-end">
              <Col span={9}>
                <TextField.IconField
                  className="listing-filter"
                  size={"large"}
                  suffix={<FaSearch />}
                  placeholder={"Search Ads"}
                  value={state.keyword}
                  onChange={(e) =>
                    setState({
                      ...state,
                      keyword: e.target.value,
                    })
                  }
                />
              </Col>
              {/* <Col span={9} className="user-location-search">
                <TextField.Autocomplete
                    inputStyle={{ width: "100%" }}
                    suffixIcon={<Icon.FaSearch size={16} color="black" />}
                    size={"large"}
                    onClear={handleClearLocation}
                    notFoundContent={"No location found"}
                    value={location ? location : undefined}
                    placeholder={"Search by location"}
                    onSearch={handleSearchLocation}
                    onSelect={handleSelectLocation}
                    options={users?.locations}
                />
                </Col> */}
              <Col span={6}>
                <TextField.SelectField
                  inputStyle={{ width: "100%" }}
                  className="listing-filter"
                  size={"large"}
                  allowClear={false}
                  onChange={(value) => {
                    if (value === "all") {
                      setState({
                        ...state,
                        status: "",
                      });
                    } else {
                      setState({
                        ...state,
                        status: value,
                      });
                    }
                  }}
                  value={state.status === "" ? "all" : state.status}
                  options={[
                    {
                      label: "All",
                      value: "all",
                    },
                    {
                      label: "Active",
                      value: "active",
                    },
                    {
                      label: "Pending",
                      value: "pending",
                    },
                    {
                      label: "Expired",
                      value: "expired",
                    },
                  ]}
                />
              </Col>
              <Col span={5}>
                <Button.Basic
                  size={"large"}
                  buttonStyle={{
                    backgroundColor: "#7836ff",
                    color: Colors.White,
                    width: "100%",
                    height: "45px",
                    fontSize: "14px",
                    fontFamily: Fonts[MontserratRegular],
                    borderRadius: "10px",
                    border: "none",
                  }}
                  text={"Send Email to All"}
                  onClick={handleOpenBulkEmailModal}
                />
              </Col>
              <Col span={4}>
                <Button.Basic
                  size={"large"}
                  buttonStyle={{
                    backgroundColor: Colors.BlueText,
                    color: Colors.White,
                    width: "100%",
                    height: "45px",
                    fontSize: "16px",
                    fontFamily: Fonts[MontserratRegular],
                    borderRadius: "10px",
                    border: "none",
                  }}
                  text={"Create Ad"}
                  onClick={handleCreateOpen}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Tabs activeKey={activeTab} onChange={handleTabChange}>
          <Tabs.TabPane tab="Short Ads" key="1">
            <Table.Basic
              columns={[
                {
                  title: "Sno",
                  dataIndex: "sno",
                  key: "sno",
                  render: (text, record, i) => (
                    <span
                      className="ml-10 table-cell"
                      title={state.offset + (i + 1)}
                    >
                      {state.offset + (i + 1)}
                    </span>
                  ),
                },

                {
                  title: "Title",
                  dataIndex: "title",
                  key: "title",
                  render: (text, record) => (
                    <span className="ml-10 table-cell" title={text}>
                      {text}
                    </span>
                  ),
                },
                {
                  title: "Upload Date",
                  dataIndex: "uploaded_at",
                  key: "uploaded_at",
                  render: (text, record) => (
                    <span className="ml-10 table-cell" title={text}>
                      {text.length > 15 ? `${text.slice(0, 15)}...` : text}
                    </span>
                  ),
                },
                {
                  title: "User Name",
                  dataIndex: "author",
                  key: "user_name",
                  render: (text, record) => (
                    <span
                      className="ml-10 table-cell"
                      title={record?.author?.name}
                    >
                      {record?.author?.name || "N/A"}
                    </span>
                  ),
                },
                {
                  title: "User Email",
                  dataIndex: "author",
                  key: "user_email",
                  render: (text, record) => (
                    <span
                      className="ml-10 table-cell"
                      title={record?.author?.email}
                    >
                      {record?.author?.email || "N/A"}
                    </span>
                  ),
                },
                {
                  title: "Duration",
                  dataIndex: "duration",
                  key: "duration",
                  render: (text, record) => (
                    <span className="ml-10 table-cell" title={text}>
                      {moment(record?.end_date).diff(record?.end_date, "days")}
                    </span>
                  ),
                },
                {
                  title: "File",
                  dataIndex: "file",
                  key: "file",
                  render: (text, record) => {
                    const isVideo = videoExt?.some((ext) =>
                      text?.endsWith(ext)
                    );
                    return isVideo ? (
                      <Avatar
                        size={50}
                        shape="square"
                        icon={<FaFileVideo />}
                        className="flex items-center justify-center cursor-pointer"
                        onClick={() => mediaPlayerHandler(isVideo, text)}
                      />
                    ) : (
                      <Avatar
                        size={50}
                        shape="square"
                        className="cursor-pointer"
                        src={`${process.env.REACT_APP_MEDIA_BASE_URL}${text}`}
                        onClick={() => mediaPlayerHandler(isVideo, text)}
                      />
                    );
                  },
                },
                {
                  title: "Status",
                  dataIndex: "status",
                  key: "status",
                  render: (text, record) => (
                    <div className="flex-row-align-center">
                      <span
                        className="table-cell mx-15"
                        style={{
                          color:
                            text === "active"
                              ? Colors.BlueText
                              : text === "expired"
                                ? Colors.RedText
                                : Colors.YellowText,
                          backgroundColor:
                            text === "active"
                              ? "#7836FF1A"
                              : text === "expired"
                                ? "#FF606B1A"
                                : "#f0ac021a",
                          padding: "10px",
                          borderRadius: "10px",
                          textTransform: "capitalize",
                        }}
                      >
                        {text}
                      </span>
                    </div>
                  ),
                },
                {
                  title: "Email",
                  dataIndex: "",
                  key: "email_action",
                  render: (text, record) => (
                    <span
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <MdEmail
                        size={26}
                        color="#7836FF"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenEmailModal(record)}
                        title="Send Email"
                      />
                    </span>
                  ),
                },
                {
                  title: "Edit",
                  dataIndex: "",
                  key: "",
                  render: (text, record) => (
                    <div className="flex-row-align-center">
                      <span
                        className="d-block mr-2"
                        onClick={() => handleOpen(record)}
                      >
                        <img
                          src={Images.EditIcon}
                          width={36}
                          className="cursor"
                        />
                      </span>
                    </div>
                  ),
                },
                {
                  title: "Delete",
                  dataIndex: "",
                  key: "",
                  render: (text, record) => (
                    // <div className="flex-row-align-center">

                    //   <span className="">
                    //     <Popconfirm
                    //       title="Delete file"
                    //       description="Are you sure you want delete this user's record?"
                    //       onConfirm={() => handleDeleteAds(record?.id)}
                    //       icon={<CiCircleRemove size={26} color="red" />}
                    //       placement="topRight"
                    //       okText="Yes"
                    //       cancelText="No, Keep it"
                    //     >
                    //       <img
                    //         src={Images.DeleteIcon}
                    //         width={26}
                    //         className="cursor"
                    //       />
                    //     </Popconfirm>
                    //   </span>
                    // </div>
                    <span
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <Popconfirm
                        title="Are you sure you want to delete this user?"
                        onConfirm={() => handleDeleteAds(record?.id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <MdDelete
                          size={26}
                          color="#FF606B"
                          style={{ cursor: "pointer" }}
                          title="Delete User"
                        />
                      </Popconfirm>
                    </span>
                  ),
                },
              ]}
              data={ads?.ads}
              loading={ads.isLoading}
            />
            {ads.count > 10 && (
              <Row justify={"center"} className="mt-10">
                <Col>
                  <Pagination.Basic
                    onChange={handlePagination}
                    pageSize={10}
                    current={page}
                    total={ads.count}
                  />
                </Col>
              </Row>
            )}
          </Tabs.TabPane>

          <Tabs.TabPane tab="Long Ads" key="2">
            <Table.Basic
              columns={[
                {
                  title: "Sno",
                  dataIndex: "sno",
                  key: "sno",
                  render: (text, record, i) => (
                    <span
                      className="ml-10 table-cell"
                      title={state.offset + (i + 1)}
                    >
                      {state.offset + (i + 1)}
                    </span>
                  ),
                },
                {
                  title: "User ID",
                  dataIndex: "author",
                  key: "user_id",
                  render: (text, record) => (
                    <span
                      className="ml-10 table-cell"
                      title={record?.author?.id}
                    >
                      {record?.author?.id || "N/A"}
                    </span>
                  ),
                },
                {
                  title: "User Name",
                  dataIndex: "author",
                  key: "user_name",
                  render: (text, record) => (
                    <span
                      className="ml-10 table-cell"
                      title={record?.author?.name}
                    >
                      {record?.author?.name || "N/A"}
                    </span>
                  ),
                },
                {
                  title: "Title",
                  dataIndex: "title",
                  key: "title",
                  render: (text, record) => (
                    <span className="ml-10 table-cell" title={text}>
                      {text}
                    </span>
                  ),
                },
                {
                  title: "Upload Date",
                  dataIndex: "uploaded_at",
                  key: "uploaded_at",
                  render: (text, record) => (
                    <span className="ml-10 table-cell" title={text}>
                      {text.length > 15 ? `${text.slice(0, 15)}...` : text}
                    </span>
                  ),
                },
                {
                  title: "Duration",
                  dataIndex: "duration",
                  key: "duration",
                  render: (text, record) => (
                    <span className="ml-10 table-cell" title={text}>
                      {moment(record?.end_date).diff(record?.end_date, "days")}
                    </span>
                  ),
                },
                {
                  title: "File",
                  dataIndex: "file",
                  key: "file",
                  render: (text, record) => {
                    const isVideo = videoExt?.some((ext) =>
                      text?.endsWith(ext)
                    );
                    return isVideo ? (
                      <Avatar
                        size={50}
                        shape="square"
                        icon={<FaFileVideo />}
                        className="flex items-center justify-center cursor-pointer"
                        onClick={() => mediaPlayerHandler(isVideo, text)}
                      />
                    ) : (
                      <Avatar
                        size={50}
                        shape="square"
                        className="cursor-pointer"
                        src={`${process.env.REACT_APP_MEDIA_BASE_URL}${text}`}
                        onClick={() => mediaPlayerHandler(isVideo, text)}
                      />
                    );
                  },
                },
                {
                  title: "Status",
                  dataIndex: "status",
                  key: "status",
                  render: (text, record) => (
                    <div className="flex-row-align-center">
                      <span
                        className="table-cell mx-15"
                        style={{
                          color:
                            text === "active"
                              ? Colors.BlueText
                              : text === "expired"
                                ? Colors.RedText
                                : Colors.YellowText,
                          backgroundColor:
                            text === "active"
                              ? "#7836FF1A"
                              : text === "expired"
                                ? "#FF606B1A"
                                : "#f0ac021a",
                          padding: "10px",
                          borderRadius: "10px",
                          textTransform: "capitalize",
                        }}
                      >
                        {text}
                      </span>
                    </div>
                  ),
                },
                {
                  title: "Email",
                  dataIndex: "",
                  key: "email_action",
                  render: (text, record) => (
                    <span
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <MdEmail
                        size={26}
                        color="#7836FF"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenEmailModal(record)}
                        title="Send Email"
                      />
                    </span>
                  ),
                },
                {
                  title: "Action",
                  dataIndex: "",
                  key: "",
                  render: (text, record) => (
                    <div className="flex-row-align-center">
                      <span
                        className="d-block mr-2"
                        onClick={() => handleOpen(record)}
                      >
                        <img
                          src={Images.EditIcon}
                          width={30}
                          className="cursor"
                        />
                      </span>
                      <span className="">
                        <Popconfirm
                          title="Delete file"
                          description="Are you sure you want delete this user's record?"
                          onConfirm={() => handleDeleteAds(record?.id)}
                          icon={<CiCircleRemove size={20} color="red" />}
                          placement="topRight"
                          okText="Yes"
                          cancelText="No, Keep it"
                        >
                          <img
                            src={Images.DeleteIcon}
                            width={28}
                            className="cursor"
                          />
                        </Popconfirm>
                      </span>
                    </div>
                  ),
                },
              ]}
              data={ads?.ads}
              loading={ads.isLoading}
            />
            {ads.count > 10 && (
              <Row justify={"center"} className="mt-10">
                <Col>
                  <Pagination.Basic
                    onChange={handlePagination}
                    pageSize={10}
                    current={page}
                    total={ads.count}
                  />
                </Col>
              </Row>
            )}
          </Tabs.TabPane>
        </Tabs>
      </div>

      <Modal.Basic
        className="modal-lg"
        centered={true}
        title=""
        closable={false}
        open={isOpen}
        handleCancel={handleCancel}
        children={<EditAds closeModal={handleCancel} data={selectedData} />}
      />

      <Modal.Basic
        className="modal-lg"
        centered={true}
        title=""
        closable={false}
        destroyOnClose={true}
        open={isCreateOpen}
        handleCancel={handleCreateCancel}
        children={<CreateAd closeModal={handleCreateCancel} />}
      />

      <Modal.Basic
        className="modal-lg"
        centered={true}
        title=""
        destroyOnClose={true}
        open={mediaPlayerOpen}
        handleCancel={() => {
          setMediaPlayerOpen(false);
          setMediaUrl("");
          setMediaType("");
        }}
        children={
          <div className="w-full flex items-center justify-center">
            {mediaType == "image" ? (
              <img src={mediaUrl} className="w-full h-full object-cover" />
            ) : (
              <video
                src={mediaUrl}
                autoPlay
                className="w-full h-full"
                controls
              />
            )}
          </div>
        }
      />

      {/* Single Email Modal */}
      <AntModal
        title="Send Email to Ad Author"
        open={emailModalVisible}
        onCancel={handleCloseEmailModal}
        footer={[
          <AntButton key="cancel" onClick={handleCloseEmailModal}>
            Cancel
          </AntButton>,
          <AntButton
            key="send"
            type="primary"
            onClick={handleSendEmail}
            disabled={!emailForm.message}
          >
            Send
          </AntButton>,
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Name</label>
          <TextField.IconField
            value={selectedUser?.author?.name || ""}
            disabled
            style={{ marginTop: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Email</label>
          <TextField.IconField
            value={selectedUser?.author?.email || ""}
            disabled
            style={{ marginTop: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Message</label>
          <TextField.Textarea
            rows={4}
            value={emailForm.message}
            onChange={(e) =>
              setEmailForm({ ...emailForm, message: e.target.value })
            }
            placeholder="Type your message here..."
            style={{ marginTop: "8px" }}
          />
        </div>
        <div className="gap-4">
          <label style={{ fontWeight: "bold" }}>Attachments</label>
          <div>
            <Upload
              multiple
              beforeUpload={() => false}
              onChange={handleFileChange}
              fileList={emailForm.attachments.map((file, idx) => ({
                uid: idx,
                name: file.name,
                status: "done",
                originFileObj: file,
              }))}
            >
              <AntButton icon={<UploadOutlined />} style={{ marginTop: "8px" }}>
                Select Files
              </AntButton>
            </Upload>
          </div>
        </div>
      </AntModal>

      {/* Bulk Email Modal */}
      <AntModal
        title={`Send Email to All ${state.type === "short" ? "Short" : "Long"
          } Ads Users`}
        open={bulkEmailModalVisible}
        onCancel={handleCloseBulkEmailModal}
        footer={[
          <AntButton key="cancel" onClick={handleCloseBulkEmailModal}>
            Cancel
          </AntButton>,
          <AntButton
            key="send"
            type="primary"
            onClick={handleSendBulkEmail}
            disabled={!emailForm.message}
          >
            Send
          </AntButton>,
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Message</label>
          <TextField.Textarea
            rows={4}
            value={emailForm.message}
            onChange={(e) =>
              setEmailForm({ ...emailForm, message: e.target.value })
            }
            placeholder="Type your message here..."
            style={{ marginTop: "8px" }}
          />
        </div>
        <div>
          <label style={{ fontWeight: "bold" }}>Attachments</label>
          <div>
            <Upload
              multiple
              beforeUpload={() => false}
              onChange={handleFileChange}
              fileList={emailForm.attachments.map((file, idx) => ({
                uid: idx,
                name: file.name,
                status: "done",
                originFileObj: file,
              }))}
            >
              <AntButton icon={<UploadOutlined />} style={{ marginTop: "8px" }}>
                Select Files
              </AntButton>
            </Upload>
          </div>
        </div>
      </AntModal>
    </>
  );
}

export default AdsManagement;
